<template>
  <div class="maincen">
    <div class="catalog">
      <div class="line"></div>
      <div class="catalogTit">我的学习</div>
    </div>
    <div class="center">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="立体教材" name="1">
          <el-row :gutter="80">
            <el-col :span="6" v-for="item in teamaterialList" :key="item.fid">
              <div class="grid-content bg-purple" @click="showDetail(item.fid)">
                <div class="imgBox">
                  <img :src="item.coverlogo" alt />
                </div>

                <div class="metTit">{{item.teamatName}}</div>
                <div class="metuser">作者：{{item.teamatAuthor}}</div>
              </div>
            </el-col>
          </el-row>
          <el-pagination
          @current-change="changepage"
          class="pagination"
          layout="prev, pager, next"
          :total="total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="微课" name="0">
          <div v-for=" item in microCourseList" :key="item.fid">
            <div class="contents">
              <div class="contentsTit">{{item.microName}}</div>
              <!-- <div class="btn">开始测试</div> -->
            </div>
            <div class="convideo" v-for=" data in item.courseFile" :key="data.fileId">
              <div>{{data.fileName}}</div>
              <div @click="openVideo(data.filePath)">
                <img src="../../assets/img/videologo.png" alt />
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 微课播放器 -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <div class="player">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          style="object-fit:fill"
          :options="playerOptions"
          :x5-video-player-fullscreen="true"
          @pause="onPlayerPause($event)"
          @play="onPlayerPlay($event)"
          @fullscreenchange="onFullscreenChange($event)"
          @click="fullScreen"
          id="video1"
        ></video-player>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- /微课播放器 -->
  </div>
</template>
<script>
import { api } from '../../assets/api/axios'
export default {
  data() {
    return {
      activeName: '1',
      dialogVisible: false,
      total:0,
      par:{
        pageNum:1,
        pageSize:8,
        courseType:1
      },
      teamaterialList :[],
      microCourseList :[],
      playerOptions: {
        //playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: 'video/mp4',
            src:''
          }
        ],
        poster: '',
        width: '',
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          fullscreenToggle: true //全屏按钮
        }
      }
    }
  },
  watch: {
    dialogVisible: function(val) {
      console.log(val)
      if (val == false) {
        this.$refs.videoPlayer.player.pause()
      }
    }
  },
  computed: {
      player() {
        return this.$refs.videoPlayer.player
      }
  },
  methods: {
    async loadMyStudy(){
      var res = await api.post('/front/personal/myStudyCourseForPC',this.par)
      if (res.data) {
        if (this.par.courseType == 1) {
          this.total = res.data.total;
          this.teamaterialList = res.data.list;
        }else if (this.par.courseType == 0) {
          this.microCourseList = res.data;
        }else{
          this.teamaterialList = [];
          this.microCourseList = [];
        }
         
      }
      console.log("列表数据--",res.data);
      
    },
    changepage(e){
      console.log("当前页数=====",e);
      this.par.pageNum = e;
      this.loadMyStudy()
      
    },
    handleClick(tab, event) {
      console.log(tab, event)
      this.par.courseType = tab.name == '1'?1:tab.name == '0'?0:null;
      this.par.pageNum = 1;
      this.loadMyStudy()
    },
    showDetail(fid){
      this.$router.push({
        path: '/teachingmat/Matdetails',
        query: {
          fid: fid
        }
      })
    },
    // 视频方法
    fullScreen() {
      const player = this.$refs.videoPlayer.player
      player.requestFullscreen() //调用全屏api方法
      player.isFullscreen(true)
      player.play()
    },
    openVideo(filePath){
      console.log("shushushushsu==",this.$refs.videoPlayer);
      
      this.playerOptions.sources[0].src = filePath;
      this.dialogVisible = true;

    },
    onPlayerPlay(player) {
      player.play()
    },
    onPlayerPause(player) {
      // alert("pause");
    }
  },
  created(){
    this.loadMyStudy()
  }
}
</script>
<style lang="scss" scoped>
.maincen {
  margin: 0 30px;
  min-height: 712px;
}
.catalog {
  overflow: hidden;
  padding: 20px 0 10px;
  border-bottom: 1px solid #e6e6e6;
  .line {
    width: 4px;
    height: 20px;
    background: rgba(181, 14, 5, 1);
    float: left;
    margin-right: 8px;
  }
  .catalogTit {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }
}
.metTit {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  margin: 10px 0;
}
.metuser {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
}
.imgBox {
  width: 100%;
  height: 181px;
  img {
    width: 100%;
    height: 100%;
  }
}
.contents {
  overflow: hidden;
  .contentsTit {
    margin-bottom: 20px;
    float: left;
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
  }
}
.convideo {
  height: 35px;
  overflow: hidden;
  div:nth-child(1) {
    font-size: 13px;
    color: rgba(102, 102, 102, 1);
    float: left;
  }
  div:nth-child(2) {
    float: right;
  }
}
</style>
